document.addEventListener('DOMContentLoaded', () => {
  const galleries = document.querySelectorAll('.event-gallery');

  galleries.forEach((gallery) => {
    const items = Array.from(gallery.querySelectorAll('[data-gallery-item]'));
    const lightbox = gallery.querySelector('[data-gallery-lightbox]');
    const content = gallery.querySelector('[data-gallery-content]');
    const caption = gallery.querySelector('[data-gallery-caption]');
    const closeButton = gallery.querySelector('[data-gallery-close]');
    const prevButton = gallery.querySelector('[data-gallery-prev]');
    const nextButton = gallery.querySelector('[data-gallery-next]');

    let currentIndex = 0;

    if (!items.length || !lightbox || !content) return;

    function openLightbox(index) {
      currentIndex = index;
      renderItem();

      lightbox.classList.add('is-active');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.classList.add('event-gallery-lock');
    }

    function closeLightbox() {
      lightbox.classList.remove('is-active');
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('event-gallery-lock');
      content.innerHTML = '';
      caption.textContent = '';
    }

    function renderItem() {
      const item = items[currentIndex];
      const type = item.dataset.type;
      const src = item.dataset.src;
      const alt = item.dataset.alt || '';
      const captionText = item.dataset.caption || '';

      content.innerHTML = '';
      caption.textContent = captionText;

      if (!src) {
        caption.textContent = 'Für dieses Video wurde noch keine Videodatei ausgewählt.';
        return;
      }

      if (type === 'video') {
        const video = document.createElement('video');
        video.src = src;
        video.controls = true;
        video.autoplay = true;
        video.playsInline = true;
        video.preload = 'metadata';
        content.appendChild(video);
      } else {
        const image = document.createElement('img');
        image.src = src;
        image.alt = alt;
        content.appendChild(image);
      }
    }

    function showPrev() {
      currentIndex = (currentIndex - 1 + items.length) % items.length;
      renderItem();
    }

    function showNext() {
      currentIndex = (currentIndex + 1) % items.length;
      renderItem();
    }

    items.forEach((item, index) => {
      item.addEventListener('click', () => openLightbox(index));
    });

    closeButton?.addEventListener('click', closeLightbox);
    prevButton?.addEventListener('click', showPrev);
    nextButton?.addEventListener('click', showNext);

    lightbox.addEventListener('click', (event) => {
      if (event.target === lightbox) {
        closeLightbox();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (!lightbox.classList.contains('is-active')) return;

      if (event.key === 'Escape') closeLightbox();
      if (event.key === 'ArrowLeft') showPrev();
      if (event.key === 'ArrowRight') showNext();
    });
  });
});